import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import store from '@/store';
import { menuAside } from '@/menu';
import router from '@/router';
import { asyncRoutes } from '@/router/routes';
export default function () {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var menus, admin, data, userInfo, roles, isHX, routes, route, redirectName, firstMenu, firstRoute;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          menus = menuAside;
          admin = false;
          data = store.state.cpscc.menus;
          if (data) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          roles = [];
          isHX = false;
          if (store.state.cpscc.userInfo && store.state.cpscc.userInfo.data2) {
            userInfo = store.state.cpscc.userInfo.data2;
            roles = userInfo.roles;
            admin = store.state.cpscc.userInfo.data2.admin;
            isHX = store.state.cpscc.isHX;
          }
          menus.forEach(function (menu) {
            if (Array.isArray(menu.children)) {
              menu.children = menu.children.filter(function (child) {
                if (child.meta) {
                  if (child.meta.permission) {
                    if (child.meta.permission === 'admin') {
                      return admin;
                    }
                    if (child.meta.permission === 'cpscc') {
                      return roles.includes('函证中心管理员') || roles.includes('发函操作员') || roles.includes('回函操作员');
                    } else if (child.meta.permission === 'sender') {
                      return roles.includes('函证中心管理员') || roles.includes('发函操作员');
                    } else if (child.meta.permission === 'replyPerson') {
                      return roles.includes('函证中心管理员') || roles.includes('回函操作员');
                    } else if (child.meta.permission === 'isGroup') {
                      return !((roles.includes('发函操作员') || roles.includes('回函操作员')) && !roles.includes('函证中心管理员'));
                    } else if (child.meta.permission === 'cpsccAdmin') {
                      return roles.includes('函证中心管理员');
                    }
                    var res = data.find(function (d) {
                      return d.n99Ehname === child.meta.permission;
                    });
                    if (res) {
                      return res.code !== -1;
                    }
                  }
                  if (child.meta.hx && isHX) {
                    return true;
                  }
                }
                return false;
              });
            }
          });
          menus = menus.filter(function (menu) {
            if (menu.title === '首页') {
              return true;
            }
            if (Array.isArray(menu.children) && menu.children.length) {
              return true;
            }
          });
          store.commit('d2admin/menu/asideSet', menus);
          routes = asyncRoutes.filter(function (item) {
            if (admin) {
              return true;
            }
            if (item.meta && item.meta.permission) {
              if (roles.length === 0) {
                return item.meta.base;
              } else {
                var permission = item.meta.permission;
                var _permission = new Set(permission);
                var _roles = new Set(roles);
                var intersectionSet = new Set(_toConsumableArray(_permission).filter(function (x) {
                  return _roles.has(x);
                }));
                var res = Array.from(intersectionSet);
                return res.length > 0;
              }
            }
            return true;
          });
          route = router.options.routes.find(function (item) {
            return item.path === '/';
          }); // router.options.routes = router.options.routes.filter((item)=>{
          //   return item.path !== '/'
          // })
          if (route) {
            if (Array.isArray(menus) && menus[0] && Array.isArray(menus[0].children) && menus[0].children[0]) {
              firstMenu = menus[0].children[0].path;
              firstRoute = routes.find(function (item) {
                return item.path === firstMenu;
              });
              if (firstRoute) {
                redirectName = firstRoute.name;
              }
            }
            routes = routes.map(function (item, index) {
              if (item.path === 'index') {
                return _objectSpread(_objectSpread({}, item), {}, {
                  redirect: redirectName ? {
                    name: redirectName
                  } : undefined
                });
              }
              return item;
            });
            route.children = [].concat(_toConsumableArray(routes), _toConsumableArray(route.children));
            route.redirect.name = 'index';
            router.addRoute(route);
          }
          store.commit('d2admin/page/init', router.options.routes);
          return _context.a(2, Promise.resolve());
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}